import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { syncI18nLocale } from '../i18n';

export default function useLocale() {
  const store = useStore();
  const { t, locale } = useI18n();

  const currentLocale = computed(() => store.state.locale || 'en');

  const setLocale = (newLocale) => {
    const resolved = syncI18nLocale(newLocale);
    store.commit('setLocale', resolved);
  };

  const toggleLocale = () => {
    setLocale(currentLocale.value === 'tr' ? 'en' : 'tr');
  };

  return {
    t,
    locale,
    currentLocale,
    setLocale,
    toggleLocale,
  };
}
